import $ from 'jquery';
import UIkit from 'uikit';

window.addEventListener('px-ready', function () {
    $('.px-form input:not([name=favorites]),.px-form select').on('change',function(){
        pxRedoUrl();
    });
    initSelects();
    initSearch();
    initCriterias();
    $('.showmode a').attr('data-no-swup', '').on('click', function (e) {
        e.preventDefault();
        var val = $(this).data('value');
        if (!$(this).parent().hasClass(val + 'Active')) {
            $('.px-form [name="display"]').val(val).trigger('change');
            $(this).parent().removeClass('listActive cardsActive').addClass(val + 'Active');
        }
    });
    $('.px-form').trigger('change');
})

function initSelects() {
    $('.px-form').on('search-results-refreshed', function (e, data) {
        var posts = $(data.content).find('[data-total-posts]').attr('data-total-posts');
        $('.nbresults .nb').text($(data.content).find('[data-total-posts]').attr('data-total-posts'));
        if(posts<2){
            $('.nbresults .label').text($('.nbresults .label').attr('data-singular'));
        }else{
            $('.nbresults .label').text($('.nbresults .label').attr('data-plural'));
        }
    });
    $('.px-form').on('keydown', '.ms-search input', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
            return false;
        }
    });
    $('.px-form select').each(function () {
        var self = $(this);
        $(this).wrap('<div class="uk-position-relative"></div>')
        $(this).before('<div class="counter"></div>')

        var attr = $(this).attr('multiple'), isAjaxCriterias = self.attr('name').indexOf('criterias[misc]') > -1;

        if (typeof attr !== typeof undefined && attr !== false) {
            $(this).on('change', updateSelectCounters);
            var ph = $(this).attr('placeholder'), request = null;

            $(this).multipleSelect({
                placeholder: ph,
                minimumCountSelected: 0,
                noMatchesFound: objectL10n.noMatchesFound,
                filter: true,
                selectAll: false,
                countSelected: ph,
                allSelected: ph,
                isAjaxCriterias: isAjaxCriterias,
                onClick: function (view) {
                    self.multipleSelect('close');
                },
                onFocus: function (view) {
                    if (isAjaxCriterias) {
                        $(this).find('.placeholder').html('');
                    }
                    $(this).parent().removeClass('is-open');
                },
                onFilter: function (text) {
                    if (!this.isAjaxCriterias) {
                        return;
                    }
                    var $multiselect = self.next('.ms-parent');
                    if (text.length > 2 && $multiselect.data('last_text') != text) {
                        $multiselect.data('last_text', text);
                        //DO ajax
                        if (request) {
                            request.abort();
                            request = null;
                        }
                        var data = { 'action': 'search_misc_criterias', 'lang': $('html').attr('lang').split('-').shift(), 's': text, 'selected': self.val() ? self.val().join(',') : null };
                        request = $.ajax({
                            type: "GET",
                            dataType: "json",
                            url: "/wp-admin/admin-ajax.php",
                            data: data,
                        }).done(function (data) {
                            self.find('option').not(':selected').remove();
                            for (var i in data) {
                                self.append('<option value="' + data[i].value + '">' + data[i].label + '</option>');
                            }
                            if (self.find('option').length) {
                                self.multipleSelect('refresh');
                            }
                            $multiselect.find('.ms-search input').addClass('has-search').val(text).focus();
                            //THen show choices
                            $multiselect.removeClass('hide-choices');
                        }).fail(function (xhr, textStatus) {
                            if (textStatus == 'abort') {
                                return;
                            }
                            UIkit.notification({
                                message: 'Search error2!' + textStatus,
                                status: 'danger',
                                pos: 'top-center',
                                timeout: 1500
                            });
                        });
                    } else if (text.length <= 1) {
                        $multiselect.addClass('hide-choices');
                    }
                },
                onOpen: function () {
                    if (this.isAjaxCriterias) {
                        self.next('.ms-parent').addClass('hide-checkboxes');
                    }
                },
                onClose: function () {
                    if (this.isAjaxCriterias) {
                        self.next('.ms-parent').addClass('hide-checkboxes').find('.ms-choice .placeholder').html(ph);
                    }
                },
                onBlur: function (view) {
                    var $multiselect = self.next('.ms-parent');
                    $(this).parent().addClass('is-open');
                    $multiselect.find('.ms-search input').removeClass('has-search')
                }
            });
        }
    })
    updateSelectCounters()
    $('body').on('keyup', '.ms-search input', function () {
        if ($(this).val() == '') {
            $(this).removeClass('has-search');
        } else {
            $(this).addClass('has-search');
        }
    })
}

function updateSelectCounters() {
    $('.px-form select').each(function () {
        var ph = $(this).attr('data-placeholder');

        var numberSelected = $(this).find(':selected').length;
        if (numberSelected) {
            $(this).parent().find('.counter').addClass('sel');
        } else {
            $(this).parent().find('.counter').removeClass('sel')
        }
        $(this).parent().find('.counter').html(numberSelected);
        $(this).parent().find('.counter').attr('data-nb', numberSelected)
    })

}

function initSearch() {
    if ($('[name="univins-criteria-search"]').length) {
        var $form = $('[name="univins-criteria-search"]').parents('form').first();
        var search = new Search($form);
        $(document).on('favoritesAdded favoritesRemoved', function (e, data) {
            var $input = $form.find('[name=favorites]'), $label = $input.next().find('.count');
            $input.val(data.join(','));
            $label.text($label.text().replace(/[0-9]+/, data.length));
        });
    }

}

var Search = function ($form) {
    this.$form = $form;
    this.mainCriteria = null;
    this.selectedCriterias = {};
    this.suspendSearch = false;
    this.activeSearch = false;
    $form.on('change', $.proxy(this.updateCriterias, this));
    $form.on('reset', $.proxy(function (e) {
        e.preventDefault();
        $('.px-checkbox input[type=checkbox]', this.$form).prop('checked', false);
        this.enableAllCriterias();
        this.unselectAllCriterias(true);
        this.refresh();
        updateSelectCounters();
    }, this));
    this.updateCriterias();
};

Search.prototype.debug = function (msg) {
    //console.log(msg);
}

Search.prototype.updateCriterias = function (e) {
    //Gather criterias from select fields
    if (this.suspendSearch || (typeof e !== 'undefined' && $(e.target).is('input[data-name]'))) {
        return;
    }
    var data = this.serializeForm();
    if (this.isNewSearch(data.criterias)) {
        return;
    }
    if (Object.keys(data.criterias).length) {
        if (!this.mainCriteria) {
            var keys = Object.keys(data.criterias), max = 0;
            if (keys.length === 1) {
                this.mainCriteria = keys[0];
            } else {
                for (var i in keys) {
                    if (data.criterias[keys[i]].length > max) {
                        this.mainCriteria = keys[i];
                    }
                }
            }
        }
        data.criterias = this.orderMainCriteria(data.criterias);
    } else if (this.activeSearch && typeof this.activeSearch.criterias !== 'undefined' && this.activeSearch.criterias.length) {
        this.mainCriteria = null;
        this.enableAllCriterias();
        this.refresh();
        return;
    }
    this.debug(data.criterias);

    data.action = 'active_search_criterias';
    $.ajax({
        type: "GET",
        dataType: "json",
        url: "/wp-admin/admin-ajax.php",
        data: data,
    }).done($.proxy(function (data) {
        this.debug(data);
        if (data === true) {
            this.enableAllCriterias();
            this.$form.trigger('change_criterias');
            return;
        }
        this.disableAllCriterias();
        this.enableCriterias(data);
        this.refresh();
    }, this)).fail(function () {
        UIkit.notification({
            message: 'Search error!',
            status: 'danger',
            pos: 'top-center',
            timeout: 1500
        });
    });
}
Search.prototype.isNewSearch = function (criterias) {
    criterias = Object.keys(criterias).sort().reduce((r, k) => (r[k] = criterias[k], r), {});
    if (JSON.stringify(criterias) == JSON.stringify(this.activeSearch)) {
        return false;
    }
    this.activeSearch = criterias;
    return true;
}
Search.prototype.disableCriterias = function (values) {
    this.debug('DISABLING');
    var total = values.length;
    for (var i = 0; i < total; i++) {
        var $input = this.$form.find('select.criterias option[value="' + values[i] + '"]');
        if ($input.length) {
            $input.prop('disabled', true);
            $input.prop('selected', false);
        } else { console.error('error finding: ' + values[i]) }
    }
};
Search.prototype.enableCriterias = function (values) {
    this.debug('ENABLING');
    var total = values.length;
    for (var i = 0; i < total; i++) {
        var $input = this.$form.find('select.criterias option[value="' + values[i] + '"]');
        if ($input.length) {
            $input.prop('disabled', false);
        }
    }
};
Search.prototype.enableAllCriterias = function () {
    this.debug('ENABLING ALL');
    this.$form.find('select.criterias option').prop('disabled', false);
};
Search.prototype.disableAllCriterias = function () {
    this.debug('DISABLING ALL');
    this.$form.find('select.criterias option:not(:selected)').prop('disabled', true).prop('selected', false);
};
Search.prototype.unselectAllCriterias = function (includeMisc) {
    if (typeof includeMisc === 'undefined') {
        includeMisc = false;
    }
    this.debug('UNSELECT');
    this.mainCriteria = null;
    if (includeMisc) {
        this.$form.find('option:selected').prop('selected', false);
    } else {
        this.$form.find('select.criterias option:selected').prop('selected', false);
    }
};
Search.prototype.refresh = function () {
    this.suspendSearch = true;
    this.$form.find('select.criterias').each(function () {
        var disabled = $(this).find('option:not([disabled])').length === 0;
        $(this).prop('disabled', disabled);
        $(this).multipleSelect('refresh');
        $(this).multipleSelect(disabled ? 'disable' : 'enable');
    });
    this.suspendSearch = false;
};
Search.prototype.orderMainCriteria = function (criterias) {
    var o = {}, main_criteria = this.mainCriteria;
    if (main_criteria) {
        o[main_criteria] = criterias[main_criteria];
    }
    var keys = Object.keys(criterias);
    for (var i in keys) {
        if (keys[i] === main_criteria) {
            continue;
        }
        o[keys[i]] = criterias[keys[i]];
    }

    return o;
};
Search.prototype.serializeForm = function () {
    this.debug('SERIAL');
    var o = {}, a = this.$form.serializeArray();
    $.each(a, function () {
        if (this.name == 'univins-criteria-search' || !this.name.match(/^criterias\[/)) {
            return;
        }
        var name = this.name.replace(/\[\]/, '').replace(/^criterias\[(.*?)\]/, '$1');
        if (o[name]) {
            if (!o[name].push) {
                o[name] = [o[name]];
            }
            o[name].push(this.value || '');
        } else {
            o[name] = [this.value || ''];
        }
    });

    return { criterias: o };
}

function initCriterias() {
    if ($('[name="univins-criteria-search"]').length) {
        new Criterias($('.px-produits-results-head .badges'), $('[name="univins-criteria-search"]').parents('form').first());
    }
}

var Criterias = function ($wrapper, $form) {
    this.$wrapper = $wrapper;
    this.$wrapper.on('click', '.remove', $.proxy(this.removeBadge, this));
    this.$form = $form;
    this.$form.on('change reset', $.proxy(this.update, this));
}

Criterias.prototype.update = function () {
    var criterias = {};
    this.$form.find(':selected').each(function () {
        criterias[$(this).val()] = $(this).text();
    });
    this.$wrapper.children().addClass('to-remove').each(function () {
        var val = $(this).data('value');
        if (criterias.hasOwnProperty(val)) {
            $(this).removeClass('to-remove');
            delete criterias[val];
        }
    });
    this.$wrapper.find('.to-remove').remove();
    for (var i in criterias) {
        var $badge = this.createBadge(i, criterias[i]);
        this.$wrapper.append($badge);
    }
    if (this.$wrapper.find('.uk-badge').length || this.$form.find('input[type=checkbox]:checked').length) {
        this.$form.find('[type=reset]').prop('disabled', false).removeClass('is-reset').addClass('is-color-green has-hover is-border');
    } else {
        this.$form.find('[type=reset]').prop('disabled', true).addClass('is-reset').removeClass('is-color-green has-hover is-border');
    }

    if (this.$form.find('input[name=favorites]:checked').length) {
        this.$wrapper.hide();
    } else {
        this.$wrapper.show();
    }
}

Criterias.prototype.createBadge = function (value, label) {
    var $badge = $('<span class="uk-badge"></span>');
    $badge.data('value', value);
    $badge.append('<span class="label">' + label + '</span>');
    $badge.append('<span class="remove"><img src="' + this.$wrapper.data('closeIcon') + '" /></span>');
    return $badge;
}

Criterias.prototype.removeBadge = function (e) {
    var $badge = $(e.currentTarget).parent(), val = $badge.data('value');
    this.$form.find('[value="' + val + '"]').prop('selected', false).trigger('change');
};

function pxRedoUrl(){
    var url = window.location.href;
    url = url.split('?');
    url = url[0]+'?';
    $('.px-form input[type="text"]').each(function(){
        if($(this).attr("name")){
            url += $(this).attr("name")+'='+$(this).val()+'&';
        }
    });
    $('.px-form select').each(function(){
        var answer = '';
        var array = $(this).val();
        if(array){
            //if(array.isArray()){
                var answer = array.toString();
            //}
            url += $(this).attr("name")+'='+answer+'&';
        }
    });
    $('.px-form input[type="checkbox"]:checked').each(function(){
        if($(this).attr("name")){
            url += $(this).attr("name")+'=1&';
        }
    });
    window.history.pushState('x','Title',url);
    $('[data-share-url]').each(function(){
        var shareurl = $(this).attr('data-share-url');
        if(shareurl){
            shareurl = shareurl.replace('sharetourl',url)
            $(this).attr('href',shareurl);
        }
    })
}